import EventEmitter from "eventemitter3";
import { EnumRopCards, type RopCard } from "../models/dados-indicadores.model";
import { RopAlarmSSEData } from "../models/alarm.model";

type DadosIndicadoresRealTimeEvent = {
  connected: () => void;
  reconnecting: (reason?: string) => void;
  disconnected: (reason?: string) => void;
  error: (errorMessage: string) => void;
  ropCardUpdate: (ropCardUpdate: RopCard) => void;
  ropActiveAlarmUpdate: (ropActiveAlarmUpdate: RopAlarmSSEData) => void;
};

export class DadosIndicadoresEventManager extends EventEmitter<DadosIndicadoresRealTimeEvent> {
  private readonly _eventSource: EventSource;

  public constructor(
    usinaId: number | string,
    clientId: string,
    token: string
  ) {
    console.debug("Criando DadosIndicadoresEventManager");
    super();

    const apiBaseUrl = import.meta.env.VITE_LINK_API;
    if (!apiBaseUrl) {
      console.warn("API BASE URL não definida");
    }

    const sseUrl = new URL(
      "/api/v1/DadosIndicadores",
      // "/v1/DadosIndicadores",
      import.meta.env.VITE_LINK_API
    );
    sseUrl.searchParams.set("usinaId", usinaId.toString());
    sseUrl.searchParams.set("clientId", clientId);
    sseUrl.searchParams.set("token", token);

    this._eventSource = new EventSource(sseUrl);
    this._eventSource.onopen = this.handleOpen.bind(this);
    this._eventSource.onerror = this.handleError.bind(this);
    this._eventSource.onmessage = this.handleMessageWithoutEvent.bind(this);
    this._eventSource.addEventListener(
      "ropCardUpdate",
      this.handleRopCardUpdate.bind(this)
    );
    this._eventSource.addEventListener(
      "clienterror",
      this.handleClientError.bind(this)
    );
  }

  private handleOpen(_ev: Event) {
    // console.debug("Lendo Open", _ev);
    this.emit("connected");
  }

  private handleError(_ev: Event) {
    // console.debug("Lendo Error", _ev);
    this.emit("reconnecting");
  }

  private handleMessageWithoutEvent(event: MessageEvent<unknown>) {
    console.debug("Lendo Message sem evento", event);
  }

  private handleRopCardUpdate(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento RopCardUpdate", event);

    if (!event.data || typeof event.data !== "string") {
      console.warn("Evento RopCardUpdate vazio ou com tipo inválido", event);
      return;
    }

    let ropCardUpdate: RopCard;
    try {
      const parsedEvtData = JSON.parse(event.data);

      ropCardUpdate = parsedEvtData;
    } catch (error) {
      console.error(
        error,
        "Erro ao fazer parse do evento RopCardUpdate",
        event
      );
      return;
    }

    if (ropCardUpdate.type == EnumRopCards.AlarmesAtivos) {
      this.handleActiveAlarmsUpdate(event);
      return;
    }
    // console.debug(
    //   "Emitindo evento ropCardUpdate",
    //   ropCardUpdate
    // );
    this.emit("ropCardUpdate", ropCardUpdate);
  }

  private handleActiveAlarmsUpdate(event: MessageEvent<unknown>) {
    if (!event.data || typeof event.data !== "string") {
      console.warn(
        "Evento RopActiveAlarmUpdate vazio ou com tipo inválido",
        event
      );
      return;
    }

    let ropActiveAlarmUpdate: RopAlarmSSEData;
    try {
      const parsedEvtData = JSON.parse(event.data);

      ropActiveAlarmUpdate = parsedEvtData;
    } catch (error) {
      console.error(
        error,
        "Erro ao fazer parse do evento handleActiveAlarmsUpdate",
        event
      );
      return;
    }

    this.emit("ropActiveAlarmUpdate", ropActiveAlarmUpdate);
  }

  private handleClientError(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento ClientError", event);
    this.disconnect("Erro nas informações do cliente tempo real");

    if (!event.data || typeof event.data !== "string") {
      console.warn("Evento ClientError vazio ou com tipo inválido", event);
      return;
    }

    const errorMessage = event.data;
    this.emit("error", errorMessage);
  }

  private disconnect(reason?: string) {
    console.debug("Desconectando DadosIndicadoresEventManager", reason);
    this.emit("disconnected", reason);
    this._eventSource.close();
  }

  public destroy() {
    console.debug("Destruindo DadosIndicadoresEventManager");
    this.disconnect("Cliente cancelou a conexão");
    this.removeAllListeners();
  }
}
